"use strict";

var LoggerInstance = require("js-logger").get("OtherAddressesHelper");

var AccountStore = require("./AccountStore");
var DefaultBillingAndShippingAddressHelper = require("./DefaultBillingAndShippingAddressHelper");
var SmartyStreets = require("./SmartyStreets");

var AccountFormHelper = require("../accountComponents/AccountFormHelper");
var BillingAddressHelper = require("../accountComponents/BillingAddressHelper");

var ActionsHelper = require("../actions/ActionsHelper");

var AccountApi = require("../api/AccountApi");

var Spinner = require("../client/Spinner");

var SubmitButtonHelper = require("../commonComponents/SubmitButtonHelper");
var ValidationHelper = require("../commonComponents/ValidationHelper");

var Constants = require("../designer/Constants");

var ApiHelper = require("../shared/ApiHelper");
var BootstrapPrompt = require("../shared/BootstrapPrompt");
var HtmlHelper = require("../shared/HtmlHelper");
var LinkMessageHelper = require("../shared/LinkMessageHelper");
var PartialResponseHelper = require("../shared/PartialResponseHelper");

var singleDocumentSelector = "[data-component='documents.populated.document']";
var singleDocumentTypeSelector = "[data-component='documents.populated.documentType']";

var DocumentsHelper = {
	initialize: function (isDesignMode, $documentsComponent) {
		var $parentSelector = $documentsComponent || $('body');

		$parentSelector.find(singleDocumentSelector).click((event) => {
			window.AccountActions.downloadDocument(event);
		});

		$parentSelector.find(singleDocumentTypeSelector).click((event) => {
			var $documentType = $(event.currentTarget).closest(singleDocumentTypeSelector);
			window.AccountActions.loadDocumentsPartial(event, $documentType.attr("data-document-type-code"));
		});
	},
};

module.exports = DocumentsHelper;
